import { styled } from '@mui/material/styles';
import { Dropdown, DropdownProps } from '../../../atoms/Dropdown';
import { DropdownContent } from '../../MoreActionsMenu';

type Props = {
    options: OptionType<any>[];
    selectedOption?: OptionType['value'];
    // eslint-disable-next-line
    onSelectOption(option: OptionType<any>): void;
    filterText?: string;
    maxHeight?: number;
    width?: number;
    listboxId?: string;
    listboxLabel?: string;
} & DropdownProps;

export type OptionType<T = string | number> = {
    label: string;
    value: T;
};

export const AdminFilterDropdown = ({
    options = [],
    selectedOption,
    onSelectOption,
    filterText,
    maxHeight,
    width,
    listboxId,
    listboxLabel,
    ...dropdownProps
}: Props) => {
    return (
        <Dropdown {...dropdownProps}>
            <DropdownContent
                width={width}
                maxHeight={maxHeight}
                role="listbox"
                id={listboxId}
                aria-label={listboxLabel}
                onClick={(e) => e.stopPropagation()}
            >
                {options.map((item, ix) => {
                    const { label, value } = item;
                    const isSelected = value === selectedOption;
                    const matchFilterText =
                        !!filterText && label?.toLocaleLowerCase()?.startsWith(filterText?.toLowerCase());

                    const matchingText = label?.substring(0, filterText?.length);
                    const labelCut = label?.substring(filterText?.length!);

                    return (
                        <Option
                            key={`${value}_${ix}`}
                            role="option"
                            aria-selected={isSelected}
                            id={listboxId ? `${listboxId}-option-${ix}` : undefined}
                            isSelected={isSelected}
                            onClick={() => onSelectOption(item)}
                        >
                            <span>
                                {matchFilterText ? (
                                    <>
                                        <strong>{matchingText}</strong>
                                        {labelCut}
                                    </>
                                ) : (
                                    label
                                )}
                            </span>
                        </Option>
                    );
                })}
            </DropdownContent>
        </Dropdown>
    );
};

const Option = styled('button')<{ isSelected?: boolean }>(({ theme, isSelected = false }: any) => ({
    ...theme.typography.labels.large,
    background: theme.palette.semantic.bg.default,
    border: 'none',
    outline: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 8px',
    cursor: 'pointer',
    color: theme.palette.semantic.int.selected,
    fontWeight: 400,
    ':hover': {
        background: theme.palette.neutral[100]
    },
    ':first-child': {
        borderRadius: '6px 6px 0 0'
    },
    ':last-child': {
        borderRadius: '0 0 6px 6px'
    },
    ':only-child': {
        borderRadius: '6px'
    },
    ...(isSelected && {
        background: theme.palette.semantic.bg.brandLight1
    }),
    strong: {
        fontWeight: 700
    }
}));
